
import Vue from 'vue'
import BigTop from '@/components/BigTop.vue'
// import TemporaryContestBanner from '@/components/TemporaryContestBanner.vue'
import Block from '@/components/Block.vue'

export default Vue.extend({
  name: 'Introduction',
  components: {
    BigTop,
    // TemporaryContestBanner,
    Block,
  },
  data: () => ({}),
})
